module.exports = __webpack_public_path__ + "res/img_back_rtl.cfc043b089708bfc7e9433b0dfbfb2eb.png";